import { Link } from 'react-router-dom';
import { Button } from '@/components/common/Button';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-md-cream">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-md-graphite mb-4">404</h1>
        <p className="text-xl text-md-ink mb-8">Page not found</p>
        <Link to="/">
          <Button variant="primary" size="lg">
            Go Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
